import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type { LayerAssignmentBatchResult } from '#/domain/catalog/LayerAssignment'

export class AssignLayerUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    layerIds: string[],
    layerCategoryId?: string,
  ): Promise<LayerAssignmentBatchResult> {
    return this.repository.assignLayerToOrganization(organizationId, layerIds, layerCategoryId)
  }
}
